import { useTranslation } from "react-i18next";
import contract from "../../../images/contract.png";
import currencyLogo from "../../../images/currency-logo.jpg";
import dashboardLogo from "../../../images/dashboard.png";
import { Icon } from "@iconify/react";
import { Inbox, Mails } from "lucide-react";

export const MenuList = () => {
  const { t } = useTranslation();
  return [
    {
      title: `${t("sidebarItemDashboard")}`,
      classsChange: "nav-label",
      iconStyle: (
        <>
          <img
            style={{
              height: "18px",
              width: "20px",
              filter: "brightness(0) invert(1)",
            }}
            src={dashboardLogo}
            alt=""
          />
          &ensp; &ensp;
        </>
      ),
      to: "dashboard",
    },
    {
      title: `${t("sidebarItemUsers")}`,
      classsChange: "nav-label",
      iconStyle: <i className="fa fa-users text-light"></i>,
      to: "users",
      iconPath: "/src/images/",
    },
    {
      title: `${t("sidebarItemBusiness")}`,
      classsChange: "nav-label",
      iconStyle: <i className="fa fa-briefcase text-light"></i>,
      to: "business",
    },
    {
      title: `${t("sidebarItemAssignedBusinesses")}`,
      classsChange: "nav-label",
      iconStyle: <i className="fa fa-briefcase text-light"></i>,
      to: "assignbusiness",
    },
    {
      title: `${t("sidebarItemRequestedBusinesses")}`,
      classsChange: "nav-label",
      iconStyle: <i className="fa fa-inbox text-light"></i>,
      to: "requested-business",
    },
    {
      title: `${t("sidebarItemBuyerProfile")}`,
      classsChange: "nav-label",
      iconStyle: <i class="fa fa-user text-light" aria-hidden="true"></i>,
      to: "buyer",
    },
    {
      title: `${t("sidebarItemSellerProfile")}`,
      classsChange: "nav-label",
      iconStyle: <i class="fa fa-user text-light" aria-hidden="true"></i>,
      to: "seller",
    },

    {
      title: `${t("createBuyerProfile")}`,
      classsChange: "nav-label",
      iconStyle: <i class="fa fa-user-plus text-light" aria-hidden="true"></i>,
      to: "create-buyer",
    },
    {
      title: `${t("createSellerProfile")}`,
      classsChange: "nav-label",
      iconStyle: <i class="fa fa-user-plus text-light" aria-hidden="true"></i>,
      to: "create-seller",
    },
    {
      title: `${t("sidebarItemProfiles")}`,
      classsChange: "mm-collapse",
      iconStyle: <i className="fa fa-user text-light"></i>,
      content: [
        {
          title: `${t("sidebarItemBuyerProfile")}`,
          classsChange: "nav-label",
          to: "buyer",
        },
        {
          title: `${t("sidebarItemSellerProfile")}`,
          classsChange: "nav-label",
          to: "seller",
        },
        {
          title: `${t("sidebarItemProfessionalProfile")}`,
          classsChange: "nav-label",
          to: "professional",
        },
        {
          title: `${t("sidebarItemRepresentativeProfile")}`,
          classsChange: "nav-label",
          to: "representative",
        },
        {
          title: `${t("sidebarItemAdministratorProfile")}`,
          classsChange: "nav-label",
          to: "administrator",
        },
      ],
    },
    {
      title: `${t("sidebarItemOffers")}`,
      classsChange: "nav-label",
      iconStyle: <i className="fa fa-bullhorn text-light"></i>,
      to: "offers",
    },
    {
      title: `${t("sidebarItemContracts")}`,
      classsChange: "mm-collapse",
      iconStyle: (
        <>
          <img
            style={{
              height: "18px",
              width: "20px",
              filter: "brightness(0) invert(1)",
            }}
            src={contract}
            alt="contact logo"
          />
          &ensp; &ensp;
        </>
      ),
      content: [
        {
          title: `${t("legal_documents")}`,
          classsChange: "nav-label",
          to: "legal_documents",
        },
        {
          title: `${t("financial_documents")}`,
          classsChange: "nav-label",
          to: "financial_documents",
        },
        {
          title: `${t("due_diligence")}`,
          classsChange: "nav-label",
          to: "due_diligence",
        },
        {
          title: `${t("human_resources")}`,
          classsChange: "nav-label",
          to: "human_resources",
        },
        {
          title: `${t("intellectual_property")}`,
          classsChange: "nav-label",
          to: "intellectual_property",
        },
        {
          title: `${t("real_estate")}`,
          classsChange: "nav-label",
          to: "real_estate",
        },
        {
          title: `${t("compliance_regulatory")}`,
          classsChange: "nav-label",
          to: "compliance_regulatory",
        },
        {
          title: `${t("transaction_documents")}`,
          classsChange: "nav-label",
          to: "transaction_documents",
        },
        {
          title: `${t("other")}`,
          classsChange: "nav-label",
          to: "other",
        },
      ],
    },

    // {
    //   title: `${t("sidebarCalendar")}`,
    //   classsChange: "nav-label",
    //   iconStyle: (
    //     <>
    //       <img
    //         style={{ height: "18px", width: "20px", opacity: "0.5" }}
    //         src={contract}
    //         alt="contact logo"
    //       />
    //       &ensp; &ensp;
    //     </>
    //   ),
    //   to: "calendar",
    // },

    {
      title: `${t("sidebarItemSystemConfiguration")}`,
      classsChange: "mm-collapse",
      iconStyle: <i class="fa fa-cog text-light" aria-hidden="true"></i>,
      content: [
        {
          title: `${t("sidebarItemCurrencies")}`,
          classsChange: "nav-label",
          iconStyle: (
            <>
              <img
                style={{ height: "18px", width: "20px", opacity: "0.5" }}
                src={currencyLogo}
              />
              &ensp; &ensp;
            </>
          ),
          to: "currencies",
        },
        {
          title: `${t("sidebarItemContractTypes")}`,
          classsChange: "nav-label",
          iconStyle: (
            <>
              <img
                style={{ height: "18px", width: "20px", opacity: "0.5" }}
                src={contract}
              />
              &ensp; &ensp;
            </>
          ),
          to: "contracttypes",
        },
        {
          title: `${t("sidebarItemTemplateManagement")}`,
          classsChange: "nav-label",
          iconStyle: <i class="fa fa-file text-light"></i>,
          to: "templatemanagement",
        },
        {
          title: `${t("sidebarItemMessageTemplate")}`,
          classsChange: "nav-label",
          iconStyle: (
            <i class="fa fa-file-text text-light" aria-hidden="true"></i>
          ),
          to: "message-template",
        },
        {
          title: `${t("sidebarItemEventConfig")}`,
          classsChange: "nav-label",
          iconStyle: <i class="fa fa-cog text-light" aria-hidden="true"></i>,
          to: "event-config",
        },
      ],
    },

    {
      title: `${t("sidebarItemOutbox")}`,
      classsChange: "nav-label",
      iconStyle: <i class="fa fa-inbox text-light" aria-hidden="true"></i>,
      to: "outbox",
    },
    // {
    // 	title: `${t("sidebarItemDocuments")}`,
    // 	classsChange: "nav-label",
    // 	iconStyle: <i class="fa fa-file"></i>,
    // 	to: "documents",
    // },
    {
      title: `${t("sidebarItemRoles")}`,
      classsChange: "nav-label",
      iconStyle: <i className="fa fa-user text-light"></i>,
      to: "roles",
    },
    // {
    // 	title: `${t("sidebarItemTenant")}`,
    // 	classsChange: "nav-label",
    // 	iconStyle: (
    // 		<>
    // 			{" "}
    // 			<Icon
    // 				icon="iconoir:home-temperature-in"
    // 				style={{ color: "gray", fontSize: 20, marginRight: "10px" }}
    // 			/>
    // 		</>
    // 	),
    // 	to: "tenant",
    // },
    // {
    //   title: `${t("sidebarItemRates")}`,
    //   classsChange: "nav-label",
    //   iconStyle: (
    //     <>
    //       {" "}
    //       <Icon icon="carbon:review" style={{ color: "gray", fontSize: 20, marginRight: "10px" }} />
    //     </>
    //   ),
    //   to: "rates",
    // },
    {
      title: `${t("sidebarItemReport")}`,
      classsChange: "nav-label",
      iconStyle: (
        <>
          <Icon
            icon="lets-icons:flag-finish-fill"
            style={{ fontSize: 20, marginRight: "10px", color: "white" }}
          />
        </>
      ),
      to: "report",
    },
    // {
    //     title: 'Authentication',
    //     classsChange: 'nav-label',
    //     iconStyle: <i className="fa fa-lock"></i>,
    //     to: 'authentication'
    // },
    //Dashboard
    // {
    //     title: 'Dashboard',
    //     classsChange: 'mm-collapse',
    //     iconStyle: <i className="flaticon-144-layout"></i>,
    //     content: [
    //         {
    //             title: 'Dashboard',
    //             to: 'dashboard',
    //         },
    //         {
    //             title: 'Dashboard Light',
    //             to: 'dashboard-light',
    //         },
    //         {
    //             title: 'Wallet',
    //             to: 'my-wallets',
    //         },
    //         {
    //             title: 'Transactions',
    //             to: 'transactions',
    //         },
    //         {
    //             title: 'Coin Details',
    //             to: 'coin-details',
    //         },
    //         {
    //             title: 'Portofolio',
    //             to: 'portofolio',
    //         },
    //         {
    //             title: 'Market Capital',
    //             to: 'market-capital',
    //         },
    //     ],
    // },
    // {
    //     title: 'APPS',
    //     classsChange: 'nav-label'
    // },
    //Apps
    // {
    //     title: 'Apps',
    //     classsChange: 'mm-collapse',
    //     iconStyle: <i className="flaticon-077-menu-1"></i>,
    //     content: [
    //         {
    //             title: 'Profile',
    //             to: 'app-profile'
    //         },
    //         // {
    //         //     title: 'Edit Profile',
    //         //     to: 'edit-profile'
    //         // },
    //         {
    //             title: 'Post Details',
    //             to: 'post-details'
    //         },
    //         {
    //             title: 'Contact List',
    //             to: 'contact-list'
    //         },
    //         {
    //             title: 'Contact Card',
    //             to: 'contact-card'
    //         },
    //         {
    //             title: 'Project Card',
    //             to: 'project-card'
    //         },
    //         {
    //             title: 'Email',
    //             //to: './',
    //             hasMenu: true,
    //             content: [
    //                 {
    //                     title: 'Compose',
    //                     to: 'email-compose',
    //                 },
    //                 {
    //                     title: 'Index',
    //                     to: 'email-inbox',
    //                 },
    //                 {
    //                     title: 'Read',
    //                     to: 'email-read',
    //                 }
    //             ],
    //         },
    //         {
    //             title: 'Calendar',
    //             to: 'app-calender'
    //         },
    //         {
    //             title: 'Shop',
    //             //to: './',
    //             hasMenu: true,
    //             content: [
    //                 {
    //                     title: 'Product Grid',
    //                     to: 'ecom-product-grid',
    //                 },
    //                 {
    //                     title: 'Product List',
    //                     to: 'ecom-product-list',
    //                 },
    //                 {
    //                     title: 'Product Details',
    //                     to: 'ecom-product-detail',
    //                 },
    //                 {
    //                     title: 'Order',
    //                     to: 'ecom-product-order',
    //                 },
    //                 {
    //                     title: 'Checkout',
    //                     to: 'ecom-checkout',
    //                 },
    //                 {
    //                     title: 'Invoice',
    //                     to: 'ecom-invoice',
    //                 },
    //                 {
    //                     title: 'Customers',
    //                     to: 'ecom-customers',
    //                 },
    //             ],
    //         },
    //     ],
    // },
    //Charts
    // {
    //     title: 'Charts',
    //     classsChange: 'mm-collapse',
    //     iconStyle: <i className="flaticon-061-puzzle" />,
    //     content: [
    //         {
    //             title: 'RechartJs',
    //             to: 'chart-rechart',
    //         },
    //         {
    //             title: 'Chartjs',
    //             to: 'chart-chartjs',
    //         },
    //         {
    //             title: 'Sparkline',
    //             to: 'chart-sparkline',
    //         },
    //         {
    //             title: 'Apexchart',
    //             to: 'chart-apexchart',
    //         },
    //     ]
    // },
    // {
    //     title: ' COMPONENTS',
    //     classsChange: 'nav-label'
    // },
    //Boosttrap
    // {
    //     title: 'Bootstrap',
    //     classsChange: 'mm-collapse',
    //     iconStyle: <i className="flaticon-003-diamond" />,
    //     content: [
    //         {
    //             title: 'Accordion',
    //             to: 'ui-accordion',
    //         },
    //         {
    //             title: 'Alert',
    //             to: 'ui-alert',
    //         },
    //         {
    //             title: 'Badge',
    //             to: 'ui-badge',
    //         },
    //         {
    //             title: 'Button',
    //             to: 'ui-button',
    //         },
    //         {
    //             title: 'Modal',
    //             to: 'ui-modal',
    //         },
    //         {
    //             title: 'Button Group',
    //             to: 'ui-button-group',
    //         },
    //         {
    //             title: 'List Group',
    //             to: 'ui-list-group',
    //         },
    //         {
    //             title: 'Cards',
    //             to: 'ui-card',
    //         },
    //         {
    //             title: 'Carousel',
    //             to: 'ui-carousel',
    //         },
    //         {
    //             title: 'Dropdown',
    //             to: 'ui-dropdown',
    //         },
    //         {
    //             title: 'Popover',
    //             to: 'ui-popover',
    //         },
    //         {
    //             title: 'Progressbar',
    //             to: 'ui-progressbar',
    //         },
    //         {
    //             title: 'Tab',
    //             to: 'ui-tab',
    //         },
    //         {
    //             title: 'Typography',
    //             to: 'ui-typography',
    //         },
    //         {
    //             title: 'Pagination',
    //             to: 'ui-pagination',
    //         },
    //         {
    //             title: 'Grid',
    //             to: 'ui-grid',
    //         },
    //     ]
    // },
    //plugins
    // {
    //     title: 'Plugins',
    //     classsChange: 'mm-collapse',
    //     iconStyle: <i className="flaticon-053-heart" />,
    //     content: [
    //         {
    //             title: 'Select 2',
    //             to: 'uc-select2',
    //         },
    //         // {
    //         //     title:'Noui Slider',
    //         //     to: 'uc-noui-slider',
    //         // },
    //         {
    //             title: 'Sweet Alert',
    //             to: 'uc-sweetalert',
    //         },
    //         {
    //             title: 'Toastr',
    //             to: 'uc-toastr',
    //         },
    //         {
    //             title: 'Jqv Map',
    //             to: 'map-jqvmap',
    //         },
    //         {
    //             title: 'Light Gallery',
    //             to: 'uc-lightgallery',
    //         },
    //     ]
    // },
    // {
    //     title: 'Redux',
    //     classsChange: 'mm-collapse',
    //     iconStyle: <i className="flaticon-381-book"></i>,
    //     content: [
    //         {
    //             title: 'Todo',
    //             to: 'todo'
    //         },
    //     ]
    // },
    //Widget
    // {
    //     title: 'Widget',
    //     //classsChange: 'mm-collapse',
    //     iconStyle: <i className="flaticon-381-settings-2" />,
    //     to: 'widget-basic',
    // },
    //Forms
    // {
    //     title: 'Forms',
    //     classsChange: 'mm-collapse',
    //     iconStyle: <i className="flaticon-044-file" />,
    //     content: [
    //         {
    //             title: 'Form Elements',
    //             to: 'form-element',
    //         },
    //         {
    //             title: 'Wizard',
    //             to: 'form-wizard',
    //         },
    //         {
    //             title: 'CkEditor',
    //             to: 'form-ckeditor',
    //         },
    //         {
    //             title: 'Pickers',
    //             to: 'form-pickers',
    //         },
    //         {
    //             title: 'Form Validate',
    //             to: 'form-validation',
    //         },
    // {
    //     title: 'Authentication',
    //     classsChange: 'nav-label',
    //     iconStyle: <i className="fa fa-lock"></i>,
    //     to: 'authentication'
    // },
    //Dashboard
    // {
    //     title: 'Dashboard',
    //     classsChange: 'mm-collapse',
    //     iconStyle: <i className="flaticon-144-layout"></i>,
    //     content: [
    //         {
    //             title: 'Dashboard',
    //             to: 'dashboard',
    //         },
    //         {
    //             title: 'Dashboard Light',
    //             to: 'dashboard-light',
    //         },
    //         {
    //             title: 'Wallet',
    //             to: 'my-wallets',
    //         },
    //         {
    //             title: 'Transactions',
    //             to: 'transactions',
    //         },
    //         {
    //             title: 'Coin Details',
    //             to: 'coin-details',
    //         },
    //         {
    //             title: 'Portofolio',
    //             to: 'portofolio',
    //         },
    //         {
    //             title: 'Market Capital',
    //             to: 'market-capital',
    //         },
    //     ],
    // },
    // {
    //     title: 'APPS',
    //     classsChange: 'nav-label'
    // },
    //Apps
    // {
    //     title: 'Apps',
    //     classsChange: 'mm-collapse',
    //     iconStyle: <i className="flaticon-077-menu-1"></i>,
    //     content: [
    //         {
    //             title: 'Profile',
    //             to: 'app-profile'
    //         },
    //         // {
    //         //     title: 'Edit Profile',
    //         //     to: 'edit-profile'
    //         // },
    //         {
    //             title: 'Post Details',
    //             to: 'post-details'
    //         },
    //         {
    //             title: 'Contact List',
    //             to: 'contact-list'
    //         },
    //         {
    //             title: 'Contact Card',
    //             to: 'contact-card'
    //         },
    //         {
    //             title: 'Project Card',
    //             to: 'project-card'
    //         },
    //         {
    //             title: 'Email',
    //             //to: './',
    //             hasMenu: true,
    //             content: [
    //                 {
    //                     title: 'Compose',
    //                     to: 'email-compose',
    //                 },
    //                 {
    //                     title: 'Index',
    //                     to: 'email-inbox',
    //                 },
    //                 {
    //                     title: 'Read',
    //                     to: 'email-read',
    //                 }
    //             ],
    //         },
    //         {
    //             title: 'Calendar',
    //             to: 'app-calender'
    //         },
    //         {
    //             title: 'Shop',
    //             //to: './',
    //             hasMenu: true,
    //             content: [
    //                 {
    //                     title: 'Product Grid',
    //                     to: 'ecom-product-grid',
    //                 },
    //                 {
    //                     title: 'Product List',
    //                     to: 'ecom-product-list',
    //                 },
    //                 {
    //                     title: 'Product Details',
    //                     to: 'ecom-product-detail',
    //                 },
    //                 {
    //                     title: 'Order',
    //                     to: 'ecom-product-order',
    //                 },
    //                 {
    //                     title: 'Checkout',
    //                     to: 'ecom-checkout',
    //                 },
    //                 {
    //                     title: 'Invoice',
    //                     to: 'ecom-invoice',
    //                 },
    //                 {
    //                     title: 'Customers',
    //                     to: 'ecom-customers',
    //                 },
    //             ],
    //         },
    //     ],
    // },
    //Charts
    // {
    //     title: 'Charts',
    //     classsChange: 'mm-collapse',
    //     iconStyle: <i className="flaticon-061-puzzle" />,
    //     content: [
    //         {
    //             title: 'RechartJs',
    //             to: 'chart-rechart',
    //         },
    //         {
    //             title: 'Chartjs',
    //             to: 'chart-chartjs',
    //         },
    //         {
    //             title: 'Sparkline',
    //             to: 'chart-sparkline',
    //         },
    //         {
    //             title: 'Apexchart',
    //             to: 'chart-apexchart',
    //         },
    //     ]
    // },
    // {
    //     title: ' COMPONENTS',
    //     classsChange: 'nav-label'
    // },
    //Boosttrap
    // {
    //     title: 'Bootstrap',
    //     classsChange: 'mm-collapse',
    //     iconStyle: <i className="flaticon-003-diamond" />,
    //     content: [
    //         {
    //             title: 'Accordion',
    //             to: 'ui-accordion',
    //         },
    //         {
    //             title: 'Alert',
    //             to: 'ui-alert',
    //         },
    //         {
    //             title: 'Badge',
    //             to: 'ui-badge',
    //         },
    //         {
    //             title: 'Button',
    //             to: 'ui-button',
    //         },
    //         {
    //             title: 'Modal',
    //             to: 'ui-modal',
    //         },
    //         {
    //             title: 'Button Group',
    //             to: 'ui-button-group',
    //         },
    //         {
    //             title: 'List Group',
    //             to: 'ui-list-group',
    //         },
    //         {
    //             title: 'Cards',
    //             to: 'ui-card',
    //         },
    //         {
    //             title: 'Carousel',
    //             to: 'ui-carousel',
    //         },
    //         {
    //             title: 'Dropdown',
    //             to: 'ui-dropdown',
    //         },
    //         {
    //             title: 'Popover',
    //             to: 'ui-popover',
    //         },
    //         {
    //             title: 'Progressbar',
    //             to: 'ui-progressbar',
    //         },
    //         {
    //             title: 'Tab',
    //             to: 'ui-tab',
    //         },
    //         {
    //             title: 'Typography',
    //             to: 'ui-typography',
    //         },
    //         {
    //             title: 'Pagination',
    //             to: 'ui-pagination',
    //         },
    //         {
    //             title: 'Grid',
    //             to: 'ui-grid',
    //         },
    //     ]
    // },
    //plugins
    // {
    //     title: 'Plugins',
    //     classsChange: 'mm-collapse',
    //     iconStyle: <i className="flaticon-053-heart" />,
    //     content: [
    //         {
    //             title: 'Select 2',
    //             to: 'uc-select2',
    //         },
    //         // {
    //         //     title:'Noui Slider',
    //         //     to: 'uc-noui-slider',
    //         // },
    //         {
    //             title: 'Sweet Alert',
    //             to: 'uc-sweetalert',
    //         },
    //         {
    //             title: 'Toastr',
    //             to: 'uc-toastr',
    //         },
    //         {
    //             title: 'Jqv Map',
    //             to: 'map-jqvmap',
    //         },
    //         {
    //             title: 'Light Gallery',
    //             to: 'uc-lightgallery',
    //         },
    //     ]
    // },
    // {
    //     title: 'Redux',
    //     classsChange: 'mm-collapse',
    //     iconStyle: <i className="flaticon-381-book"></i>,
    //     content: [
    //         {
    //             title: 'Todo',
    //             to: 'todo'
    //         },
    //     ]
    // },
    //Widget
    // {
    //     title: 'Widget',
    //     //classsChange: 'mm-collapse',
    //     iconStyle: <i className="flaticon-381-settings-2" />,
    //     to: 'widget-basic',
    // },
    //Forms
    // {
    //     title: 'Forms',
    //     classsChange: 'mm-collapse',
    //     iconStyle: <i className="flaticon-044-file" />,
    //     content: [
    //         {
    //             title: 'Form Elements',
    //             to: 'form-element',
    //         },
    //         {
    //             title: 'Wizard',
    //             to: 'form-wizard',
    //         },
    //         {
    //             title: 'CkEditor',
    //             to: 'form-ckeditor',
    //         },
    //         {
    //             title: 'Pickers',
    //             to: 'form-pickers',
    //         },
    //         {
    //             title: 'Form Validate',
    //             to: 'form-validation',
    //         },

    //     ]
    // },
    //Table
    // {
    //     title: 'Table',
    //     classsChange: 'mm-collapse',
    //     iconStyle: <i className="flaticon-381-network" />,
    //     content: [
    //         {
    //             title: 'Table Filtering',
    //             to: 'table-filtering',
    //         },
    //         {
    //             title: 'Table Sorting',
    //             to: 'table-sorting',
    //         },
    //         {
    //             title: 'Bootstrap',
    //             to: 'table-bootstrap-basic',
    //         },

    //     ]
    // },
    //Pages
    // {
    //     title: 'Pages',
    //     classsChange: 'mm-collapse',
    //     iconStyle: <i className="flaticon-049-copy" />,
    //     content: [
    //         {
    //             title: 'Error',
    //             hasMenu: true,
    //             content: [
    //                 {
    //                     title: 'Error 400',
    //                     to: 'page-error-400',
    //                 },
    //                 {
    //                     title: 'Error 403',
    //                     to: 'page-error-403',
    //                 },
    //                 {
    //                     title: 'Error 404',
    //                     to: 'page-error-404',
    //                 },
    //                 {
    //                     title: 'Error 500',
    //                     to: 'page-error-500',
    //                 },
    //                 {
    //                     title: 'Error 503',
    //                     to: 'page-error-503',
    //                 },
    //             ],
    //         },
    //         {
    //             title: 'Lock Screen',
    //             to: 'page-lock-screen',
    //         },

    //     ]
    // },
  ];
};
